import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: "",
    });
  };

  return (
    <div className="contact-container">
      <Helmet>
        <title>Επικοινωνία - Ecunel Fitness Gym</title>
        <meta
          name="description"
          content="Επικοινωνήστε με το Ecunel Fitness Gym. Είμαστε εδώ για να απαντήσουμε στις ερωτήσεις σας."
        />
        <meta property="og:title" content="Επικοινωνία - Ecunel Fitness Gym" />
        <meta
          property="og:description"
          content="Επικοινωνήστε με το Ecunel Fitness Gym"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "Επικοινωνία με Ecunel Fitness Gym",
            description: "Στοιχεία επικοινωνίας για το Ecunel Fitness Gym",
          })}
        </script>
      </Helmet>

      <div className="contact-hero">
        <h1>Επικοινωνήστε Μαζί Μας</h1>
        <p>
          Είμαστε εδώ για να σας βοηθήσουμε. Στείλτε μας το μήνυμά σας και θα
          επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.
        </p>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <h2>Πληροφορίες Επικοινωνίας</h2>

          <div className="info-item">
            <FaHome className="info-icon" />
            <div className="info-text">
              <h3>Διεύθυνση</h3>
              <p>
                Όδος Βασιλόπουλος, 61
                <br />
                036 98, Καστοριά
                <br />
                Greece
              </p>
            </div>
          </div>

          <div className="info-item">
            <FaPhone className="info-icon" />
            <div className="info-text">
              <h3>Τηλέφωνο</h3>
              <p>+302467022500</p>
            </div>
          </div>

          <div className="info-item">
            <FaEnvelope className="info-icon" />
            <div className="info-text">
              <h3>Email</h3>
              <p>
                <a href="mailto:ecunel@hotmail.com">ecunel@hotmail.com</a>
              </p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-text">
              <h3>Αριθμός Μητρώου</h3>
              <p>49500140</p>
            </div>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>Φόρμα Επικοινωνίας</h2>

          <div className="form-group">
            <label htmlFor="firstName">Όνομα *</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Επώνυμο *</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Τηλέφωνο</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              pattern="^\+?[0-9\s\-]{7,20}$"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Μήνυμα *</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="btn btn-primary">
            Αποστολή Μηνύματος
          </button>
        </form>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Ευχαριστούμε!</h2>
            <p>
              Το μήνυμά σας έχει σταλεί επιτυχώς. Θα επικοινωνήσουμε μαζί σας το
              συντομότερο δυνατό.
            </p>
            <button
              className="btn btn-primary"
              onClick={() => setShowModal(false)}
            >
              Κλείσιμο
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Contact;
